export class NetworkError extends Error {
  constructor() {
    super()
    this.name = this.constructor.name
  }
}
